import { z } from 'zod';

const contactEditorial = z.object({
  name: z.string().or(z.literal('')).optional(),
  email: z.string().email().or(z.literal('')).optional(),
  phoneNumber: z
    .string()
    // check if the phone number is a swedish phone number and have 9 - 10 digits
    .regex(/^(\+46)?\d{9,10}$/)
    .or(z.literal(''))
    .optional(),
  message: z.string().min(1),
  legal: z.boolean().optional(),
});

const refinement = ({ name, email, phoneNumber, legal }: z.infer<typeof contactEditorial>, ctx: z.RefinementCtx) => {
  const isAnyFieldFilled = Boolean(name) || Boolean(email) || Boolean(phoneNumber);

  const isLegalSelected = legal === true;

  if (isAnyFieldFilled && !isLegalSelected) {
    ctx.addIssue({
      path: ['legal'],
      code: z.ZodIssueCode.custom,
      message: 'Please accept the terms and conditions',
    });
  }
};

export const ContactEditorialFormSchema = contactEditorial.superRefine(refinement);

export const ContactEditorialFormSchemaWithCaptcha = contactEditorial
  .extend({
    recaptchaToken: z.string().min(1),
  })
  .superRefine(refinement);
